import { render } from "./ProductDetailsPage.vue?vue&type=template&id=71181019&scoped=true"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js"

import "./ProductDetailsPage.vue?vue&type=style&index=0&id=71181019&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71181019"]])

export default __exports__